import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "../Cards/Card";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import NativeObject from "../../components/NativeObject/NativeObject";

function KpiCard({
  app,
  KPITitle,
  iconId,
  percentageId,
  greyValueId,
  valueId,
  customStyle,
  isMobile,
  selectedCheck,
  colorIdentfy,
  tooltip,
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (selectedCheck) {
      console.log("selected", selectedCheck);
    }
  }, [selectedCheck]);

  useEffect(() => {
    if (KPITitle) {
      setLoading(false);
    }
  }, [KPITitle]);
  return (
    <Card
      style={{
        width: "100%",
        padding: "10px",
        background: colorIdentfy,  
        justifyContent: "center",
        ...customStyle,
      }}
     
    >
      {/* TITULO */}
      <ComboHeader
        app={app}
        reference={{
          title: {
            id: KPITitle.id,
            hard: KPITitle.hardTitle,
          },
        }}
        tooltip={tooltip}
        classStyle={colorIdentfy != "" && "combo-header-kpi-title-white"}
      />

      <div
        style={{
          height: "100%",
          width: isMobile ? null : "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: isMobile ? null : "center",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: isMobile ? null : "start",
          }}
        >
          {/*CONTAINER VALUES*/}
          <div
            style={{
              width: isMobile ? "90%" : "65%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className={
                greyValueId
                  ? "containerKpiValueBold"
                  : "containerKpiValueBoldUnique"
              }
            >
              {/* VALOR PRINCIPAL */}
              <NativeObject
                
                className={colorIdentfy != "" ? "kpiValueBold" : "kpiValueBold kpi-color-text-white" }
                app={app}
                key={valueId}
                reference={{ id: valueId }}
              />
            </div>
          </div>
          {/*CONTAINER ICON*/}
          <div
            style={{
              width: isMobile ? "10%" : "35%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* PERCENTAGE*/}
            {percentageId ? (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <NativeObject
                  className="kpiValueGrey"
                  app={app}
                  key={percentageId}
                  reference={{ id: percentageId }}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}

KpiCard.defaultProps = {
  app: null,
  KPITitle: {},
  iconId: null,
  percentageId: null,
  greyValueId: null,
  valueId: null,
  selectedCheck: "",
};

KpiCard.propTypes = {
  app: PropTypes.object,
  KPITitle: PropTypes.object,
  iconId: PropTypes.string,
  percentageId: PropTypes.string,
  greyValueId: PropTypes.string,
  valueId: PropTypes.string,
  selectedCheck: PropTypes.string,
};

export default KpiCard;
